
import { defineComponent } from "vue";
import { Meshviewer } from "@ali/tide-wanhuatong-sdk/runtime";
import { mapState, mapMutations } from "vuex";

export default defineComponent({
    name: "BillBoard",
    props: {},
    computed: {
        ...mapState(['meshApp'])
    },
    data() {
        return {};
    },
    async mounted() {
        this.init();
    },
    methods: {
         ...mapMutations(['setMeshApp']),
        async init() {
            console.log("初始化三维场景");
            const { Application } = Meshviewer;
            const app = new Application(this.$refs.viewport, {
                // sceneId: "7bf6fd25-9cb9-4ef8-a456-89ed766b4787",
                // sceneId: "29743903-4954-42c0-9e63-a75172aaeb54"
                sceneId: "b74440c6-1c58-409b-8a4b-0707b8514a6c"
            });
            this.setMeshApp(app);

            app.start().then(() => {
                const cameraAPI = Application.getInstance("cameraAPI");
                cameraAPI.setCameraFov(50); // 设置合适的相机fov
                // const virtualGuiderAPI =
                //     Application.getInstance("virtualGuiderAPI");
                // virtualGuiderAPI.Init("built-in", "built-in", undefined); // 加载飞行器
            });
        },
        
    },
});
